import "./InventoryItemDetails.scss";
import { Link } from "react-router-dom";
import axios from "axios";
import React from "react";
// import ModalDelete from "../ModalDelete/ModalDelete";
import back from "../../assets/Icons/arrow_back-24px.svg";
import edit from "../../assets/Icons/edit-24px.svg";

const apiURL = `https://instock-api-rbht.onrender.com`;

class InventoryItemDetails extends React.Component {
  // class states =>
  constructor(props) {
    super(props);
    this.state = {
      item: {},
      status: "item-details-second-start__stock",
    };
  }

  // fetch item data from API and assign it to state (also changes class for in Stock element)
  fetchData() {
    axios
      .get(`${apiURL}/api/v1/inventories/${this.props.match.params.id}`)
      .then((response) => {
        this.setState({
          item: response.data,
        });

        if (response.data.status === "In Stock") {
          this.setState({
            status: "item-details-second-start__stock",
          });
        } else {
          this.setState({
            status: "item-details-second-start__noStock",
          });
        }
      });
  }
  // calls fetch data once component is mounted
  componentDidMount() {
    // change tittle of webpage
    document.title = "Inventory Item Details";
    this.fetchData();
  }
  render() {
    return (
      <>
        <div className="background">
          <div className="item">
            <div className="item-head">
              <button
                className="item__back"
                onClick={this.props.history.goBack}
              >
                <img className="item__back-img" src={back} alt="back arrow" />
              </button>
              <h1 className="item__title">{this.state.item.itemName}</h1>
              <Link to={`/inventory/edit/${this.props.match.params.id}`}>
                <button className="item__edit">
                  <img className="item__edit-img" src={edit} alt="back arrow" />
                  <p className="item__edit-text">Edit</p>
                </button>
              </Link>
            </div>
            <section className="item-details">
              <div className="item-details-first">
                <p className="item-details-first__title">ITEM DESCRIPTION:</p>
                <p className="item-details-first__description">
                  {this.state.item.description}
                </p>
                <p className="item-details-first__title">CATEGORY:</p>
                <p className="item-details-first__description">
                  {this.state.item.category}
                </p>
              </div>
              <div className="item-details-second">
                <div className="item-details-second-start">
                  <div>
                    <p className="item-details-second-start__title">STATUS:</p>
                    <p className={this.state.status}>
                      {this.state.item.status}
                    </p>
                  </div>
                  <div>
                    <p className="item-details-second-start__title">
                      QUANTITY:
                    </p>
                    <p className="item-details-second-start__number">
                      {this.state.item.quantity}
                    </p>
                  </div>
                </div>
                <p className="item-details-second__title">WAREHOUSE:</p>
                <p className="item-details-second__location">
                  {this.state.item.warehouseName}
                </p>
              </div>
            </section>
          </div>
        </div>
      </>
    );
  }
}

export default InventoryItemDetails;
